module.exports = __webpack_public_path__ + "assets/img/contentBj2.afbbfc1c.png";